import { MODALITY, type Modality } from "@src/constants/filter-constants";

export const normalizeSessionTypeToken = (value: string): string => {
  const normalized = value.trim().toLowerCase();

  if (normalized.includes("virtual") || normalized.includes(MODALITY.TELEHEALTH)) {
    return MODALITY.TELEHEALTH;
  }
  if (normalized.includes(MODALITY.IN_PERSON) || normalized.includes("in person")) {
    return MODALITY.IN_PERSON;
  }
  if (normalized.includes(MODALITY.NO_PREFERENCE)) {
    return MODALITY.NO_PREFERENCE;
  }

  return normalized;
};

export const normalizeSessionTypeValue = (value: string): string => {
  const token = normalizeSessionTypeToken(value);

  if (token === MODALITY.TELEHEALTH) {
    return "Virtual";
  }
  if (token === MODALITY.IN_PERSON) {
    return "In-person";
  }

  return value.trim();
};

export const toSessionTypeValues = (sessionType?: string | string[] | null): string[] => {
  if (Array.isArray(sessionType)) {
    return sessionType;
  }
  return typeof sessionType === "string" ? [sessionType] : [];
};

export const resolveModalityFromNormalizedSessionTypes = (values: string[]): Modality => {
  const normalized = new Set(values.map(normalizeSessionTypeToken).filter(Boolean));
  const hasVirtual = normalized.has(MODALITY.TELEHEALTH);
  const hasInPerson = normalized.has(MODALITY.IN_PERSON);

  if ((hasVirtual && hasInPerson) || normalized.has(MODALITY.NO_PREFERENCE)) {
    return MODALITY.NO_PREFERENCE;
  }
  if (hasVirtual) {
    return MODALITY.TELEHEALTH;
  }
  if (hasInPerson) {
    return MODALITY.IN_PERSON;
  }
  return MODALITY.NO_PREFERENCE;
};
